(function() {
  const elBtnPrint = document.querySelector('.finalized-sales__btn-download')

  elBtnPrint?.addEventListener('click', (e) => {
    e.preventDefault()
    window.print()
  })
})()